import reveal from '../modules/scroll-reveal';

reveal('.js-reveal');